//人员趋势
const getPeopleTrendUrl = `/gateway/hc-low-carbon/digitalCommunity/getPersonTrend`;
//每日日活
const getDauUrl = `/gateway/hc-low-carbon/digitalCommunity/getDailyAmount`;
//活跃应用(人数)
const getActPeopleUrl = `/gateway/hc-low-carbon/digitalCommunity/getActivePopulation`;
//积分产生与核销
const getPointsUrl = `/gateway/hc-low-carbon/digitalCommunity/getPointData`;
export { getPeopleTrendUrl, getDauUrl, getActPeopleUrl, getPointsUrl };
